export const EDITORIAL_EVENT_DEFAULTS = {
  headerTaglineScript: 'Luxury',
  headerTaglineSans: 'STAYS CURATED FOR YOU',
  emailTitle: "An Insider's Retreat",
  ctaText: 'Book now →',
  ctaBackgroundColor: '#00a7b5',
  ctaTextColor: '#00a7b5',
  footerAccentColor: '#182852',
  featuresSectionTitle: 'Exclusive Summer Experiences',
  col1LinkText: 'Learn more →',
  col2LinkText: 'Book now →',
  col3LinkText: 'Book now →',
  logoWidth: '168px',
  logoHeight: '168px',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  richtextFields: {
    bodyHtml: `Dear :token{key="guestName" label="First name"},

We hope this message finds you well. As a valued guest, we invite you to return to {{hotelName}} and enjoy **exclusive preferred rates starting at $375** per night.

Use promo code **INSIDER** when booking online or call us to reserve your stay.`,
    col1Html: `### Terrace Evenings

Ease into the moment on our open-air terrace. Sip signature cocktails complemented by chef-curated small plates, all set against the view.`,
    col2Html: `### Weekend Seafood Boil

Indulge in crab, whole lobster, peel and eat shrimp, and more at our interactive dining experience, where live music and specialty cocktails round out the evening.`,
    col3Html: `### Sips and Sunsets

Savor golden hour with a curated selection of fine wines, seasonal bites inspired by the region, and live music.`,
    finePrintHtml: `To ensure delivery to your inbox, please add our sender address to your address book.

No longer wish to receive emails? <a href="{{unsubscribeUrl}}">Unsubscribe</a>.

[View in browser](#)`
  }
}

export default EDITORIAL_EVENT_DEFAULTS
